define("shared/components/shared/referral-promo-banner", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "later/utils/constants/segment-events", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _segmentEvents, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/constants/segment-events",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.shouldShow}}
    <div class="cRPB--banner" data-test-id="referral-promo-banner" ...attributes>
      <div class="cRPB--banner__content">
        {{svg-jar "liked" class="o--icon--sm cRPB--banner__icon"}}
        <div class="cRPB--banner__text">
          <p class="cRPB--banner__body">{{t "referral_promo.headline"}}</p>
          <p class="cRPB--banner__body">{{t "referral_promo.offer"}}</p>
          <a
            class="cRPB--banner__link"
            href={{this.referralUrl}}
            rel="noopener noreferrer"
            target="_blank"
            {{on "click" this.trackLearnMore}}
          >
            {{t "referral_promo.learn_more"}}
          </a>
        </div>
      </div>
      <Shared::Ui::Button
        @onClick={{this.dismiss}}
        @size="small"
        @variant="unstyled"
        aria-label={{t "referral_promo.dismiss"}}
        class="cRPB--banner__dismiss"
        data-test-id="referral-promo-banner-dismiss"
      >
        {{svg-jar "close" class="o--icon--xs cRPB--banner__dismissIcon"}}
      </Shared::Ui::Button>
    </div>
  {{/if}}
  */
  {
    "id": "FEcRWjC/",
    "block": "[[[41,[30,0,[\"shouldShow\"]],[[[1,\"  \"],[11,0],[24,0,\"cRPB--banner\"],[24,\"data-test-id\",\"referral-promo-banner\"],[17,1],[12],[1,\"\\n    \"],[10,0],[14,0,\"cRPB--banner__content\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"liked\"],[[\"class\"],[\"o--icon--sm cRPB--banner__icon\"]]]],[1,\"\\n      \"],[10,0],[14,0,\"cRPB--banner__text\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"cRPB--banner__body\"],[12],[1,[28,[35,2],[\"referral_promo.headline\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"cRPB--banner__body\"],[12],[1,[28,[35,2],[\"referral_promo.offer\"],null]],[13],[1,\"\\n        \"],[11,3],[24,0,\"cRPB--banner__link\"],[16,6,[30,0,[\"referralUrl\"]]],[24,\"rel\",\"noopener noreferrer\"],[24,\"target\",\"_blank\"],[4,[38,3],[\"click\",[30,0,[\"trackLearnMore\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"referral_promo.learn_more\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,4],[[16,\"aria-label\",[28,[37,2],[\"referral_promo.dismiss\"],null]],[24,0,\"cRPB--banner__dismiss\"],[24,\"data-test-id\",\"referral-promo-banner-dismiss\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[30,0,[\"dismiss\"]],\"small\",\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,1],[\"close\"],[[\"class\"],[\"o--icon--xs cRPB--banner__dismissIcon\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"&attrs\"],false,[\"if\",\"svg-jar\",\"t\",\"on\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/referral-promo-banner.hbs",
    "isStrictMode": false
  });
  const DISMISSED_KEY = 'referral-promo-banner-dismissed-session';
  const REFERRAL_URL = 'https://later.com/refer-later/';
  let ReferralPromoBannerComponent = _exports.default = (_class = class ReferralPromoBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "hasDismissed", _descriptor4, this);
    }
    get referralUrl() {
      return REFERRAL_URL;
    }
    get isDismissed() {
      return this.hasDismissed || Boolean(this.cache.retrieve(DISMISSED_KEY));
    }
    get shouldShow() {
      return Boolean(this.auth.currentAccount?.canApprovalFlow) && !this.isDismissed;
    }
    trackLearnMore() {
      this.segment.track(_segmentEvents.SegmentEventTypes.ClickedReferralPromo);
    }
    dismiss() {
      // Dismiss for the session only: the cache singleton survives SPA navigation but
      // clears on a full page reload, so the banner returns in a new session.
      this.cache.add(DISMISSED_KEY, true, {
        expiry: this.cache.maxExpiryDate(),
        persist: false
      });
      this.hasDismissed = true;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasDismissed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "trackLearnMore", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackLearnMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismiss", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dismiss"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ReferralPromoBannerComponent);
});